module.exports = __webpack_public_path__ + "static/gaaoon-hallelujah-026386e6a5c59c99a989dfb8bf16ecd3.jpg";